// Cloudinary delivery optimization.
//
// Any image served from res.cloudinary.com can be delivered smaller for free
// by asking for it in the URL: f_auto (WebP/AVIF where supported), q_auto
// (smart compression), w_<px> + dpr_auto (right-sized for the slot and the
// screen). Cloudinary derives and caches the variants; nothing is re-uploaded.
//
// Signed URLs (s--…-- segment, used for authenticated recording delivery)
// pass through untouched — the signature covers the transformation string,
// so injecting parameters would 401 them. Add transformations for those
// where the signature is generated (backend responses/media.py) instead.

const CLOUDINARY_IMAGE_UPLOAD = /^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)$/;

export function optimizedImageUrl(url, width, quality = 'auto') {
  if (!url || typeof url !== 'string') return url;
  const m = url.match(CLOUDINARY_IMAGE_UPLOAD);
  if (!m || m[2].startsWith('s--')) return url;
  const q = `q_${quality}`;
  const t = width ? `f_auto,${q},w_${Math.round(width)},dpr_auto` : `f_auto,${q}`;
  return `${m[1]}${t}/${m[2]}`;
}

// srcSet string for responsive slots, e.g. imageSrcSet(url, [400, 800]).
export function imageSrcSet(url, widths, quality = 'auto') {
  if (!url || !url.match(CLOUDINARY_IMAGE_UPLOAD)) return undefined;
  return widths.map((w) => `${optimizedImageUrl(url, w, quality)} ${w}w`).join(', ');
}
